// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"163":"a6a84f04","660":"2e02bcc8","918":"320bc8a6"}[chunkId] + ".chunk.css";
};